(() => {
  if (window.LittleMonkeezRecommendations) return;
  window.LittleMonkeezRecommendations = true;

  class LittleMonkeezProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true' || this.dataset.loading === 'true') return;
      this.dataset.loading = 'true';
      this.load();
    }

    async load() {
      try {
        const response = await fetch(this.dataset.url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);
        const html = await response.text();
        const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
        const source = parsedDocument.querySelector('lm-product-recommendations[data-lm-source]');
        const content = source && source.querySelector('[data-lm-recommendations]');

        if (content) {
          this.innerHTML = source.innerHTML;
          this.dataset.loaded = 'true';
          this.closest('.main-product__block-complementary')?.classList.add('lm-has-recommendations');
        } else {
          this.closest('.main-product__block-complementary')?.classList.add('lm-no-recommendations');
        }
      } catch (error) {
        this.dataset.error = 'true';
        console.warn('[Recommended products]', error);
      } finally {
        delete this.dataset.loading;
      }
    }
  }

  if (!customElements.get('lm-product-recommendations')) {
    customElements.define('lm-product-recommendations', LittleMonkeezProductRecommendations);
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-lm-toggle]');
    if (!toggle) return;
    const box = toggle.closest('[data-lm-recommendations]');
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    box.querySelectorAll('.lm-recommendation--extra').forEach((item) => { item.hidden = expanded; });
    toggle.setAttribute('aria-expanded', String(!expanded));
    toggle.querySelector('[data-lm-more]').hidden = !expanded;
    toggle.querySelector('[data-lm-less]').hidden = expanded;
    toggle.querySelector('[data-lm-toggle-icon]').textContent = expanded ? '+' : '−';
  });

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-lm-variant]');
    if (!select) return;
    const card = select.closest('.lm-recommendation');
    const option = select.options[select.selectedIndex];
    card.querySelector('[data-lm-variant-input]').value = option.value;
    card.querySelector('[data-lm-price]').textContent = option.dataset.price;
    const compare = card.querySelector('[data-lm-compare-price]');
    compare.textContent = option.dataset.comparePrice || '';
    compare.hidden = !option.dataset.comparePrice;
  });
})();
